
import { Checkbox } from "@/components/ui/checkbox";
import { useState } from "react";

export interface MembershipType {
  id: string;
  label: string;
}

export const MEMBERSHIP_TYPES = [
  { id: "active", label: "Actif" },
  { id: "benefactor", label: "Bienfaiteur" },
  { id: "donor", label: "Donateur" },
];

interface MembershipTypeFilterProps {
  selectedTypes: string[];
  onTypeChange: (typeId: string) => void;
}

export const MembershipTypeFilter = ({
  selectedTypes,
  onTypeChange,
}: MembershipTypeFilterProps) => {
  return (
    <div>
      <h4 className="text-sm font-semibold mb-2">Type d'adhésion</h4>
      <div className="flex flex-wrap gap-4 mb-4">
        {MEMBERSHIP_TYPES.map((type) => (
          <div key={type.id} className="flex items-center space-x-2">
            <Checkbox 
              id={`type-${type.id}`}
              checked={selectedTypes.includes(type.id)}
              onCheckedChange={() => onTypeChange(type.id)}
            />
            <label
              htmlFor={`type-${type.id}`}
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {type.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
